<template>
  <!-- 套餐 -->
  <div class="packageWrap" v-if="goodsList?.length > 0">
    <div class="packageLeft">
      <p class="fs14 fwb mb6">
        {{ goodsList[0].package?.packageName }}
      </p>
      <p>
        <span class="fs20 fwb orange">{{ currencyAndAmountFormat(goodsList[0].package?.currency, goodsList[0].package?.price) }}</span>
        <span class="fs14 tdlt ml6 fwb blackD8">({{ serviceListPriceSum(goodsList[0].package?.serviceList, goodsList[0].package?.currency) }})</span>
      </p>
      <div class="pt10">
        <!-- 适用人群 -->
        <p class="fs12">Exclusive for:</p>
        <p class="fs12 black88">
          {{ goodsList[0].package?.applicablePerson }}
        </p>
      </div>
    </div>
    <div class="packageRight">
      <div class="flex flex-direction-row details">
        <div class="mr20">
          <!-- 套餐包含： -->
          <p class="fs12 fwb">Package Includes:</p>
          <ul class="fs12 black45 lh22">
            <li v-for="child in goodsList[0].package?.serviceList" :key="'child' + child.id">
              <span class="fwb green fs12 el-icon-check"></span>
              {{ child.description }}
              <span v-if="$isNumberLike(child.serviceFee)">({{ currencyAndAmountFormat(child.currency, child.serviceFee) }})</span>
              <el-popover placement="bottom" trigger="hover" v-if="child.serviceScope">
                <span class="fs12">{{ child.serviceScope }}</span>
                <span slot="reference" class="ml2 fs13 blackD8 el-icon-question"></span>
              </el-popover>
            </li>
          </ul>
        </div>
        <!-- 第三方费用 -->
        <div class="mr20">
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            Third Party Fee:
          </p>
          <ul class="fs12 black45 lh22">
            <li
              v-for="subset in mergeSameAttrList(goodsList[0].package?.serviceList, 'thirdPartyFeeDescription', 'thirdPartyFee')"
              :key="`subset-${subset.id}`"
            >
              <span v-if="subset.thirdPartyFeeDescription">- {{ subset.thirdPartyFeeDescription }}</span>
              <span v-if="$isNumberLike(subset.thirdPartyFee)">({{ currencyAndAmountFormat(subset.currency, subset.thirdPartyFee) }})</span>
            </li>
          </ul>
        </div>
        <!-- 其他费用 -->
        <div>
          <p class="fs12 pt18 lh22">
            <span class="fwb green fs12 el-icon-check"></span>
            Other Fee:
          </p>
          <ul class="fs12 black45 lh22">
            <li v-for="other in mergeSameAttrList(goodsList[0].package?.serviceList, 'otherFeeDescription', 'otherFee')" :key="`other-${other.id}`">
              <span v-if="other.otherFeeDescription">- {{ other.otherFeeDescription }}</span>
              <span v-if="$isNumberLike(other.otherFee)">({{ currencyAndAmountFormat(other.currency, other.otherFee) }})</span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import priceCountMixin from "@/mixins/priceCountMixin";
import formatterMixin from "@/mixins/formatterMixin";
export default {
  mixins: [priceCountMixin, formatterMixin],
  props: {
    goodsList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.packageWrap {
  display: flex;
  width: 100%;
  padding: 16px;
  background-color: #fdf6ec;

  .packageLeft {
    padding-right: 16px;
    max-width: 250px;
  }

  .packageRight {
    padding-left: 16px;
    border-left: 1px solid #e4e7ed;
  }

  p {
    line-height: 20px;
    margin: 0;
    color: #011a45;
  }
}
</style>
